import * as yup from "yup";

export const addBoardUser = yup
    .object({
        user_id: yup.string().required("User is required"),
        user_role: yup.string().required("User role is required"),
    })
    .required();
